export const DEFAULT_BOOTSTRAP_RETRY_CONFIG = {
  maxRetries: 2,
  baseDelayMs: 500,
};

export function sleep(delayMs) {
  return new Promise((resolve) => {
    setTimeout(resolve, delayMs);
  });
}

export function getRetryDelayMs(baseDelayMs, attempt) {
  return baseDelayMs * Math.pow(2, attempt);
}

export function shouldRetryBootstrapError(error) {
  const status = error?.response?.status;
  const errorCode = error?.response?.data?.errorCode;

  if (status === 503) {
    return true;
  }
  if (errorCode === "AUTH_REVALIDATION_DEPENDENCY_FAILED") {
    return true;
  }
  return !error?.response;
}
